var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7687 54.4779C64.2075 54.0801 64.5 53.5498 64.5 53.0195V5.68761C64.5 4.49437 63.403 3.5 62.0866 3.5H17.9134C16.597 3.5 15.5 4.49437 15.5 5.68761V57.2621C15.5 60.6429 18.4985 63.3609 22.2284 63.3609H24.0567V59.516H22.2284C20.8388 59.516 19.7418 58.5216 19.7418 57.2621C19.7418 56.0025 20.8388 54.9419 22.2284 54.9419H26.6164V65.5485C26.6164 66.2777 27.5672 66.7417 28.2254 66.344L31.3701 64.4215C31.7358 64.2226 32.1746 64.2226 32.5403 64.4215L35.6851 66.344C36.3433 66.7417 37.294 66.344 37.294 65.5485V54.9419H58.5761C58.3567 55.6048 58.1373 56.4003 58.1373 57.2621C58.1373 58.1239 58.2836 58.8531 58.5761 59.516H39.8537V63.3609H62.3791C63.2567 63.3609 63.9881 62.8968 64.3537 62.1013C64.6463 61.3721 64.4269 60.5103 63.7687 59.98C63.7687 59.98 62.3791 58.7868 62.3791 57.1958C62.3791 56.4003 62.7448 55.7374 63.0373 55.2071C63.403 54.743 63.7687 54.4779 63.7687 54.4779Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame4);
export default __webpack_public_path__ + "static/media/frame_4.70e5cd3578299d8e4e972d02beaa0a88.svg";
export { ForwardRef as ReactComponent };